<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableElasticBlockStoreWarningDate"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="delete">
        <Button
          type="success"
          size="small"
          v-hasPermission="['monitor:elasticBlockStoreMonitor:log']"
          @click="rowClick(row)"
          >{{ $t("alarms.common.operationLog") }}</Button
        >
        <Button
          type="warning"
          size="small"
          v-hasPermission="['monitor:elasticBlockStoreMonitor:alert_rule_edit']"
          @click="addOrUpdateHandle(row.id)"
          >{{ $t("alarms.common.edit") }}</Button
        >
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            v-hasPermission="[
              'monitor:elasticBlockStoreMonitor:alert_rule_delete'
            ]"
            @click="EBSWarningModal = true"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- 操作日志详情 -->
    <alert-rule-operation-log
      v-if="alertRuleOperationLogVisible"
      ref="alertRuleOperationLog"
    ></alert-rule-operation-log>
    <!-- 删除实例模式框 -->
    <Modal v-model="EBSWarningModal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ alertRuleName }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeEBSWarning()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
    <add-or-update-elastic-block-store-warning
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
    ></add-or-update-elastic-block-store-warning>
  </div>
</template>
<script>
import AlertRuleOperationLog from "../common/AlertRuleOperationLog.vue";
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
import TableElasticBlockStore from "../ebs/TableElasticBlockStore.vue";
import AddOrUpdateElasticBlockStoreWarning from "../ebs/AddOrUpdateElasticBlockStoreWarning";
var tableElasticBlockStore = TableElasticBlockStore;
var tableEBSWarningVue = {};
export default {
  name: "TableElasticBlockStoreWarning",
  components: {
    AddOrUpdateElasticBlockStoreWarning,
    AlertRuleOperationLog
  },
  data() {
    return {
      alertRuleOperationLogVisible: false,
      addOrUpdateVisible: false,
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      EBSWarningModal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      alertRuleName: "",
      stateType: ["enabled", "disabled"],
      monitorIndexType: ["磁盘读取IOPS", "磁盘写入IOPS"],
      state: [
        "creating",
        "available",
        "in-use",
        "deleting",
        "deleted",
        "error"
      ],
      columns: [
        {
          title: this.$t("alarms.common.alertRuleName"),
          key: "alertRuleName"
        },
        {
          title: this.$t("alarms.common.status"),
          key: "state",
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  // 数据库0 enabled,1 disabled
                  props: {
                    type: "primary",
                    size: "large",
                    value: params.row.state == "enabled" // 控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": () => {
                      this.switch(params.index);
                    }
                  }
                },
                [
                  h("span", {
                    slot: "open",
                    domProps: {
                      innerHTML: this.$t("alarms.common.enable")
                    }
                  }),
                  h("span", {
                    slot: "close",
                    domProps: {
                      innerHTML: this.$t("alarms.common.disable")
                    }
                  })
                ]
              )
            ]);
          }
        },
        {
          title: this.$t("alarms.common.monitorIndex"),
          key: "monitorIndexName"
        },
        {
          title: this.$t("alarms.common.alertRule"),
          key: "alertRuleDesc"
        },
        {
          title: this.$t("alarms.common.contact"),
          key: "contactNameList"
        },
        {
          title: this.$t("alarms.common.scanType"),
          key: "scanTypeName"
        },
        {
          title: this.$t("common.operation"),
          width: 200,
          slot: "delete"
        }
      ],
      tableElasticBlockStoreWarningDate: [],
      volumeAwsId: ""
    };
  },
  beforeCreate: function() {
    tableEBSWarningVue = this;
  },
  mounted: function() {
    this.volumeAwsId = this.$route.query.volumeAwsId;
    tableEBSWarningVue.getEBSWarningData();
  },
  methods: {
    showAll: function() {
      tableEBSWarningVue.getEBSWarningData();
    },
    // 分页显示数据
    /****************************************************/
    getEBSWarningData: function() {
      eventBus.$on("alertRuleSearchName", function(val) {
        tableEBSWarningVue.alertRuleSearchName = val;
      });
      eventBus.$on("companyId", function(val) {
        tableEBSWarningVue.companyId = val;
      });
      eventBus.$on("accountId", function(val) {
        tableEBSWarningVue.accountId = val;
      });
      eventBus.$on("stateId", function(val) {
        tableEBSWarningVue.stateId = val;
      });
      eventBus.$on("typeId", function(val) {
        tableEBSWarningVue.typeId = val;
      });
      eventBus.$on("delayTypeId", function(val) {
        tableEBSWarningVue.delayTypeId = val;
      });
      eventBus.$on("volumeId", function(val) {
        tableEBSWarningVue.volumeId = val;
      });
      eventBus.$on("monitorIndex", function(val) {
        tableEBSWarningVue.monitorIndex = val;
      });
      //报警规则列表分页
      this.$api.alertRule
        .pageAlertRule({
          alertRuleName: tableEBSWarningVue.alertRuleSearchName,
          companyId: tableEBSWarningVue.companyId,
          accountId: tableEBSWarningVue.accountId,
          stateId: tableEBSWarningVue.stateId,
          typeId: tableEBSWarningVue.typeId,
          delayTypeId: tableEBSWarningVue.delayTypeId,
          pageNum: this.current,
          pageSize: this.pageSize,
          monitorModule: 11,
          volumeId:
            this.volumeAwsId == null
              ? tableEBSWarningVue.volumeId
              : this.volumeAwsId,
          monitorIndex: tableEBSWarningVue.monitorIndex
        })
        .then(res => {
          this.tableElasticBlockStoreWarningDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;

          for (
            var i = 0;
            i < this.tableElasticBlockStoreWarningDate.length;
            i++
          ) {
            // 状态
            this.tableElasticBlockStoreWarningDate[i].state = this.stateType[
              this.tableElasticBlockStoreWarningDate[i].state
            ];
            //监控指标
            this.tableElasticBlockStoreWarningDate[
              i
            ].monitorIndex = this.monitorIndexType[
              this.tableElasticBlockStoreWarningDate[i].monitorIndex
            ];
          }
        });
    },
    changePage: function(current) {
      this.current = current;
      tableEBSWarningVue.getEBSWarningData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableEBSWarningVue.getEBSWarningData();
    },
    // 销毁alertRuleSearchName
    beforeDestroy: function() {
      eventBus.$off("alertRuleSearchName");
    },
    // switch
    /****************************************************/
    switch(index) {
      this.index = index;
      // 打开是true,0启用 1禁用
      if (this.tableElasticBlockStoreWarningDate[index].state == "enabled") {
        this.changeStatusMessage(
          this.tableElasticBlockStoreWarningDate[index].id,
          "state",
          1
        );
      } else {
        this.changeStatusMessage(
          this.tableElasticBlockStoreWarningDate[index].id,
          "state",
          0
        );
      }
    },
    // 更新反馈信息某一字段
    changeStatusMessage: function(id, key, value) {
      // 编辑状态
      this.$api.alertRule
        .changeStatus({
          id: id,
          state: value
        })
        .then(res => {
          tableEBSWarningVue.getEBSWarningData();
        });
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.alertRuleName = this.tableElasticBlockStoreWarningDate[
        index
      ].alertRuleName;
    },
    removeEBSWarning: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //账户删除
      this.$api.alertRule
        .deleteAlertRule(
          "id",
          this.tableElasticBlockStoreWarningDate[lineIndex].id
        )
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableEBSWarningVue.getEBSWarningData();
            tableElasticBlockStore.methods.showAll();
            this.isDisable = false;
            this.modal_loading = false;
            this.EBSWarningModal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    },
    // 编辑报警规则
    /**********************************************************************************/
    addOrUpdateHandle: function(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 操作日志
    /****************************************************/
    rowClick: function(row) {
      this.alertRuleOperationLogVisible = true;
      this.$nextTick(function() {
        this.$refs.alertRuleOperationLog.getAlertRuleOperationLogData(row);
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/ebs/TableElasticBlockStoreWarning.vue